document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".blog-menu").forEach((menu) => {
    const tabs = menu.querySelector("[data-menu-tabs]");
    const prevBtn = menu.querySelector('[data-menu-nav="prev"]');
    const nextBtn = menu.querySelector('[data-menu-nav="next"]');
    if (!tabs || !prevBtn || !nextBtn) return;

    // Shown/hidden together, only when the tabs actually overflow — this
    // never changes mid-scroll, so the buttons' own space never jumps.
    const updateVisibility = () => {
      const hasOverflow = tabs.scrollWidth - tabs.clientWidth > 1;
      prevBtn.hidden = !hasOverflow;
      nextBtn.hidden = !hasOverflow;
      updateDisabled();
    };

    // Reflects whether there's more to scroll in each direction — toggling
    // `disabled` keeps both buttons mounted so the layout stays put.
    const updateDisabled = () => {
      const maxScroll = tabs.scrollWidth - tabs.clientWidth;
      prevBtn.disabled = tabs.scrollLeft <= 1;
      nextBtn.disabled = tabs.scrollLeft >= maxScroll - 1;
    };

    const scrollByDirection = (direction) => {
      tabs.scrollBy({left: direction * tabs.clientWidth * 0.8, behavior: "smooth"});
    };

    prevBtn.addEventListener("click", () => scrollByDirection(-1));
    nextBtn.addEventListener("click", () => scrollByDirection(1));
    tabs.addEventListener("scroll", updateDisabled, {passive: true});
    window.addEventListener("resize", updateVisibility);
    window.addEventListener("load", updateVisibility);

    updateVisibility();
  });
});
